import React, { useState, useRef } from "react";
import {
  Modal,
  TextInput,
  Button,
  Group,
  Center,
  ColorInput,
  Text,
  Select,
  NumberInput,
  Textarea,
} from "@mantine/core";
import { Dropzone } from "@mantine/dropzone";
import { IconPhoto, IconUpload, IconVideo } from "@tabler/icons-react";
import { DateInput } from "@mantine/dates";
import classes from "./add.module.css";
import { RowDataReview } from "./types";
import moment from "moment";

interface AddReviewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAddBanner: (newBannerData: RowDataReview) => void;
}

const AddReviewModal: React.FC<AddReviewModalProps> = ({
  isOpen,
  onClose,
  onAddBanner,
}) => {
  const [newBanner, setNewBanner] = useState<RowDataReview>({
    id: "",
    fullname: "",
    review: "",
    rating: 5,
    reviewDate: "",
    show: false,
    action: "Edit",
  });


  const handleAddBanner = () => {
    // Check if any required fields are empty
    if (!newBanner.fullname || !newBanner.review || !newBanner.rating || !newBanner.reviewDate) {
      alert("Please fill in all the required fields");
      return;
    }

    onAddBanner(newBanner);

    // Clear inputs and reset state
    setNewBanner({
      id: "",
      fullname: "",
    review: "",
    rating: 5,
    reviewDate: "",
      show: false,
      action: "Edit",
    });

    onClose();
  };

  const handleClose = () => {
    // Clear inputs and reset state
    setNewBanner({
      id: "",
      fullname: "",
    review: "",
    rating: 5,
    reviewDate: "",
      show: false,
      action: "Edit",
    });

    // Call the onClose function
    onClose();
  };

  return (
    <Modal
      style={{ zIndex: "100" }}
      title={
        <div style={{ textAlign: "center", fontWeight: "bold" }}>
          New Review
        </div>
      }
      opened={isOpen}
      onClose={handleClose}
    >
      <TextInput
        label="Fullname"
        placeholder="Input name"
        mb="sm"
        maxLength={255}
        value={newBanner.fullname}
        onChange={(event) =>
          setNewBanner({ ...newBanner, fullname: event.currentTarget.value })
        }
      />

        <NumberInput
            label="Rating"
            description="1-5"
            allowDecimal={false}
            allowNegative={false}
            min={1}
            max={5}
            value={newBanner?.rating}
            mb="sm"
            // onChange={(event) => setGamesFPS((prev)=>[...prev, prev[index].fps])}
            onChange={(e) => setNewBanner({ ...newBanner, rating: e })}
        />

    <Textarea
        label="Review"
      value={newBanner?.review}
      onChange={(event) => setNewBanner({ ...newBanner, review: event.currentTarget.value })}
      autosize={true}
      minRows={4}
        mb="sm"
    />

    <DateInput
        //   valueFormat="YYYY-MM-DD HH:mm:ss.SSS"
        //   dropdownType="modal"
          label="Review Date"
          placeholder="Pick date"
          mb="sm"
          required
          onChange={(e) =>
            setNewBanner({
              ...newBanner,
              reviewDate: moment(e).format("YYYY-MM-DD HH:mm:ss.SSS") ?? "",
            })
          }
        />


      {/* <ColorInput
        label="Color"
        placeholder="Select a color"
        mb="sm"
        value={newBanner.color}
        onChange={(color) => setNewBanner({ ...newBanner, color: color })}
      /> */}

      <Group className={classes.buttonBottom}>
        <Button onClick={() => onClose()} className={classes.buttonBack}>
          Back
        </Button>
        <Button onClick={handleAddBanner} className={classes.buttonSubmit}>
          Submit
        </Button>
      </Group>
    </Modal>
  );
};

export default AddReviewModal;
